import React, { PureComponent } from 'react'
import Measure from 'react-measure'
import cx from 'classnames'

import s from './Collapsible.scss'


class Collapsible extends PureComponent {

  state = {
    height: null,
  }

  handleResize = ({ bounds }) => {
    this.setState({
      height: bounds.height,
    })
  }

  render() {
    const { height } = this.state
    const { children, className, contentClassName, collapsed, onClick } = this.props

    const rootClassName = cx(s.collapsible, className)

    const style = {
      height: collapsed ? 0 : (height || 'auto'),
    }

    return (
      <div className={rootClassName} style={style} onClick={onClick}>
        <Measure onResize={this.handleResize} bounds>
          {
            ({ measureRef }) => (
              <div ref={measureRef} className={contentClassName}>
                {children}
              </div>
            )
          }
        </Measure>
      </div>
    )
  }
}


export default Collapsible
